import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=bbc3118e&scoped=true&"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordPage.vue?vue&type=style&index=0&id=bbc3118e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc3118e",
  null
  
)

export default component.exports